// Autogenerated file
export const expenseStatusesEnum = {
    Planned: "Planned",
    Completed: "Completed",
    Draft: "Draft",
};
export const expenseStatuses = [
    { label: "Запланирована", value: "Planned" },
    { label: "Завершена", value: "Completed" },
    { label: "Черновик", value: "Draft" },
];
